// Route path constants + predicates shared by main.tsx (the boot router) and
// the page components. Kept dependency-free on purpose: main.tsx imports the
// predicates statically to decide which page to render, while the heavy page
// components load via dynamic import() (AuthPage pulls in Firebase,
// PricingDemoPage pulls in lead UI). Co-locating the paths here is what lets
// the bundler keep Firebase out of the entry chunk.

export const AUTH_PATHS = {
  login: '/login',
  register: '/register',
  verifyEmail: '/verify-email',
  resetPassword: '/reset-password',
  // LEA-527: branded first-password page for pre-provisioned (white-glove) accounts.
  setPassword: '/set-password',
} as const;

export type AuthPath = (typeof AUTH_PATHS)[keyof typeof AUTH_PATHS];

export function isAuthPath(pathname: string): boolean {
  return Object.values(AUTH_PATHS).includes(pathname as AuthPath);
}

export const BILLING_PATHS = {
  success: '/billing/success',
  cancel: '/billing/cancel',
} as const;

export function isBillingReturnPath(pathname: string): boolean {
  return pathname === BILLING_PATHS.success || pathname === BILLING_PATHS.cancel;
}
